<template>
  <div class="travel-list-page">
    <div class="travel-search-container">
      <div class="travel-search">
        <input type="text"
               placeholder="请输入城市或景点名称"
               @keyup.enter="search(searchName)"
               v-model="searchName" />
        <span class="search-input-icon"
              @click="search(searchName)"></span>
      </div>
    </div>
    <div class="no-result"
         v-if="travel.length === 0">
      <div v-if="len===0"
           class="image"></div>
      <div v-if="len===0"
           class="message">没有检索到相关内容，换一个关键词试试！</div>
    </div>
    <div class="travel-list-container"
         v-else>
      <div class="travels-content">
        <div class="travels-item"
             v-for="(item, index) in travel"
             :key="index">
          <tr-item :imageUrl="processImgs(item.imgs) ? processImgs(item.imgs) : imgUrl"
                   :item="item"
                   :visitPath="`/detail/new${item.id}`">
            <div class="travels-info-wrap">
              <div class="travels-info-item">
                <div class="travel-title-wrap">
                  <a class="travel-title"
                     @click="detailFunction(item)"
                     :title="item.name">
                    {{
                      item.name.length > 25
                        ? `${item.name.slice(0, 25)}...`
                        : item.name
                    }}
                  </a>
                </div>
                <p class="travel-path"
                   :title="item.infoParagraphName">
                  {{
                    item.infoParagraphName && item.infoParagraphName.length > 50
                      ? `${item.infoParagraphName.slice(0, 50)}...`
                      : item.infoParagraphName
                  }}
                </p>
                <p class="travel-mark">
                  <span>发表时间：{{ item.updateTime | getupdateTime }}</span>
                  <span><i class="el-icon-user-solid"></i>&nbsp;用户：{{
                      item.nickName ? item.nickName : `用户${item.userId}`
                    }}</span>
                </p>
              </div>
              <div class="travels-info-bottom">
                <div class="travel-experience-wrap">
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/icon-drive-difficulty.png" />&nbsp;
                    <span>
                      驾驶难度：{{
                        item.difficulty ? item.difficulty : "--" | getdifficulty
                      }}
                    </span>
                  </span>
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/total-mileage-colorful.png" />
                    &nbsp;总里程：{{ item.totalMileage
                    }}{{
                      item.totalMileage && item.totalMileage !== ""
                        ? "公里"
                        : "--"
                    }}
                  </span>
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/icon-money.png" />
                    &nbsp;人均消费：{{ item.price ? `${item.price}元` : "--" }}
                  </span>
                </div>
              </div>
            </div>
          </tr-item>
        </div>
      </div>
      <div class="travel-page-bar"
           v-if="total > 10">
        <el-pagination background
                       layout="prev, pager, next"
                       :current-page="page"
                       :total="total"
                       @current-change="handleCurrentChange"></el-pagination>
      </div>
      <div v-if="total <= 10">
        <span>- 嗯，目前我能告诉你的就是这么多！-</span>
      </div>
    </div>
  </div>
</template>
<script>
import TrContainer from "@/components/layout/TrContainer";
import TrCard from "@/components/recommend/TrCard";
import TrItem from "@/components/travels/TrItem";
import url from "@/assets/recommend/main-image.jpg";
import { mapState, mapActions, mapMutations } from "vuex";
import { searchTravelList } from "@/axios/service/travel";
export default {
  filters: {
    getdifficulty: function (value) {
      let levelMap = new Map([
        [1, "轻松"],
        [2, "适中"],
        [3, "困难"],
        ["--", "--"]
      ]);

      return levelMap.get(value);
    },
    getupdateTime: function (value) {
      //后台返回值缺字段的情况下页面不随数据刷新
      if (value === undefined) {
        return "";
      }
      return value.slice(0, 10);
    }
  },
  components: {
    TrContainer,
    TrCard,
    TrItem
  },
  data () {
    return {
      message: "123123123123",
      searchName: "",
      page: 1,
      rows: 10,
      imgUrl: url,
      travel: [],
      len: null
    };
  },
  computed: {
    ...mapState("HomeDataStore", ["searchValue", "total", "newTravels"])
  },
  watch: {
    newTravels: {
      handler (value) {
        this.travel = value,
          this.len = value.length;
      }
    }
  },
  created () {
    this.searchName = this.searchValue;
    this.search(this.searchName);
  },
  methods: {
    processImgs (imgs) {
      if (imgs) {
        return imgs.split(";")[0];
      }
      return imgs;
    },
    ...mapMutations("HomeDataStore", ["formMutations"]),
    ...mapActions("HomeDataStore", ["getnewTravels"]),
    search (searchName) {
      this.getnewTravels({
        page: this.page,
        rows: this.rows,
        dataType: 14,
        word: searchName,
        flag: 1
      });
    },
    detailFunction (item) {
      this.formMutations(item);
      // this.$router.push({path:`/detail/${item.id}`});
      let routeUrl = this.$router.resolve({
        path: `/detail/new${item.id}`
      });
      window.open(routeUrl.href, "_blank");
    },
    handleCurrentChange (page) {
      this.getnewTravels({
        page: page,
        rows: this.rows,
        dataType: 14,
        word: this.searchName,
        flag: 1
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lesses/main/travel/travel-list.less";
</style>
